import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf/dist/entry.noworker';

export class FilePreviewer extends React.Component {
  constructor() {
    super();
    this.state = {
      numPages: 1
    };
  }

  onLoadSuccess({numPages}) {
    this.setState({numPages});
  }

  renderPreview() {
    let fileType = this.props.file.type;

    if (fileType.includes('image')) {
      return(
        <div className="file-previewer__preview">
          <img className="file-previewer__preview-image"
            src={this.props.file.preview}
            alt={this.props.file.name}
            title={this.props.file.name}/>
        </div>
      );
    } else if(fileType === "application/pdf") {
      return(
        <div className="file-previewer__preview">
          <Document
            className="file-previewer__preview-pdf"
            file={this.props.file.preview}
            onLoadSuccess={this.onLoadSuccess.bind(this)}
          >
          { this.props.renderAllPages ?
              Array.from(
                new Array(this.state.numPages),
                (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                  />
                ),
              )
              :
              <Page
                pageNumber={1}
                renderTextLayer={false}
              />
          }
          </Document>
        </div>
      );
    } else {
      return(
        <div className="file-previewer__preview">
          <span className="file-previewer__preview-none">
            NO PREVIEW AVAILABLE
          </span>
        </div>
      );
    }
  }

  render(renderAllPages=false) {
    return(
      <div className="file-previewer">
        {this.renderPreview(renderAllPages)}
      </div>
    );
  }
}

FilePreviewer.propTypes = {
  file: PropTypes.object,
  renderAllPages: PropTypes.bool
};

export default FilePreviewer;
